import { FC } from "react";

export const SadFaceIcon: FC<{}> = () => {
  return (
    <svg
      width="50"
      height="49"
      viewBox="0 0 50 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 42.875C35.1482 42.875 43.375 34.6482 43.375 24.5C43.375 14.3518 35.1482 6.125 25 6.125C14.8518 6.125 6.625 14.3518 6.625 24.5C6.625 34.6482 14.8518 42.875 25 42.875Z"
        stroke="url(#paint0_linear_734_2294)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.875 20.4166H18.9022"
        stroke="url(#paint1_linear_734_2294)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.125 20.4166H31.1522"
        stroke="url(#paint2_linear_734_2294)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 31.1448C20.6653 30.4657 21.4595 29.9263 22.3359 29.558C23.2124 29.1897 24.1535 29 25.1042 29C26.0548 29 26.996 29.1897 27.8724 29.558C28.7488 29.9263 29.543 30.4657 30.2083 31.1448"
        stroke="#9F66FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_734_2294"
          x1="43.375"
          y1="24.5"
          x2="6.625"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#473EFF" />
          <stop offset="1" stopColor="#A066FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_734_2294"
          x1="18.9022"
          y1="20.9166"
          x2="18.875"
          y2="20.9166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#473EFF" />
          <stop offset="1" stopColor="#A066FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_734_2294"
          x1="31.1522"
          y1="20.9166"
          x2="31.125"
          y2="20.9166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#473EFF" />
          <stop offset="1" stopColor="#A066FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
